import {Suspense} from 'react';
import {Outlet, createRoute, redirect} from '@tanstack/react-router';
import NotFoundPage from '@/anonymous/views/error/NotFoundPage';
import PractitionerLayout from '@/practitioner/components/layout/PractitionerLayout';
import RouteElementSkeleton from '@/shared/components/ui/skeletons/RouteElementSkeleton';
import {AppRouterContext} from '@/shared/routing';
import handleRedirectCookie from '@/shared/routing/handleRedirectCookie';
import {USER_HOME} from '@/shared/routing/paths';
import {Route as rootRoute} from '../__root';

function PractitionerRoutesLayoutComponent() {
  return (
    <PractitionerLayout>
      <Suspense fallback={<RouteElementSkeleton />}>
        <Outlet />
      </Suspense>
    </PractitionerLayout>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/u',
  component: PractitionerRoutesLayoutComponent,
  errorComponent: NotFoundPage,
  beforeLoad: function ({
    context,
    location: {pathname}
  }: {
    context: AppRouterContext;
    location: {pathname: string};
  }) {
    handleRedirectCookie({pathname, isLoggedIn: context.isLoggedIn});
    if (pathname === '/u') {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
